export default __webpack_public_path__ + "static/media/la.bceb1140.svg";